import React from 'react';
import {Navbar, Nav, Container, Button} from 'react-bootstrap';
import {Download, Github, Linkedin} from 'react-bootstrap-icons';

export const Navigation = () => {
    return (
        <Container>
            <Navbar className="justify-content-between" style={styles.navStyle} expand="lg">
                <Navbar.Brand style={styles.brandStyle}>Jaden Lesuk</Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                    <Nav className="ml-auto" >
                        {/* <Nav.Link style={styles.linkStyle}>Skills</Nav.Link>
                        <Nav.Link style={styles.linkStyle}>Projects</Nav.Link> */}

                        <Nav.Link href="https://github.com/jaden-lesuk" target="_blank">
                            <Github style={styles.iconStyle}/>
                        </Nav.Link>
                        <Nav.Link href="https://www.linkedin.com/in/lesuk-jaden-59496b195/" target="_blank">
                            <Linkedin style={styles.iconStyle}/>
                        </Nav.Link>
                        <Button variant="outline-light" style={styles.buttonStyle} href="https://drive.google.com/file/d/1IfJPgBwT3LPQZfxzUx71sKFsZtXPrsE_/view?usp=sharing" target="_blank"><Download/>  Download Resume</Button>
                        
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </Container>
    )
}

const styles = {
    navStyle: {
        marginBottom: '3vh'
    },

    brandStyle: {
        fontSize: '27px',
        color: 'white',
        fontWeight: 'bold'
    },

    linkStyle: {
        fontSize: '2.5vh',
        marginRight: '1vw'
    },

    buttonStyle: {
        fontSize: '2.5vh',
        border: 'solid 2px white',
        fontWeight: 'bold',
    },

    iconStyle: {
        fontSize: '3.5vh', 
        marginRight: '1.5vw', 
        color:'black'
    }
}